import styled, { css } from 'styled-components/macro'
import { ScreenSize, mq } from 'styles/mq'

export type Mode =
  | 'default'
  | 'fluid'
  | 'text'
  | 'restricted'
  | 'textPlusPadding'

export const Container = styled.div<{ $mode?: Mode }>`
  padding: 0 var(--spacing-sm);
  width: 100%;
  margin: 0 auto;
  max-width: calc(var(--container-width) + 2 * var(--spacing-sm));

  ${(props) =>
    props.$mode === 'text' &&
    css`
      max-width: calc(60rem + 2 * var(--spacing-sm));
    `}

  ${(props) =>
    props.$mode === 'textPlusPadding' &&
    css`
      max-width: calc(60rem + 4 * var(--spacing-sm));

      ${mq.smallOnly} {
        max-width: calc(60rem + 2 * var(--spacing-sm));
      }
    `}
  
  ${(props) =>
    props.$mode === 'restricted' &&
    css`
      max-width: calc(75rem + 2 * var(--spacing-sm));

      ${mq.large} {
        max-width: calc(${ScreenSize.LG / 10}rem + 2 * var(--spacing-sm));
      }
    `}

  ${(props) =>
    props.$mode === 'fluid' &&
    css`
      max-width: none;
    `}
`
